import showToast from '../../Components/Common/SweetAlert/ToastAlert'
import { createFeedback } from '../../redux/feedback/action'
import { useAppDispatch, type AppDispatch } from '../../redux/store'
import { useLoading } from '../../context/LoadingContext'
import { OperationalManager, Supervisor } from '../../redux/auth/types'

interface AddFeedbackParams {
  workdayId: string
  firstName: string
  lastName: string
  middleName: string
  suffix: string
  email: string
  supervisor: Supervisor
  operationalManager: OperationalManager
  feedback: string
  imageFileName?: string
  imageFile?: File
}

interface useAddFeedbackParams {
  createFeedback: (params: AddFeedbackParams) => Promise<void>
}

const useAddFeedback = (): useAddFeedbackParams => {
  const dispatch: AppDispatch = useAppDispatch()

  const { setLoading } = useLoading()

  const addFeedback = async ({
    workdayId,
    firstName,
    lastName,
    middleName,
    suffix,
    email,
    supervisor,
    operationalManager,
    feedback,
    imageFileName,
    imageFile,
  }: AddFeedbackParams): Promise<void> => {
    setLoading(true)
    try {
      await dispatch(
        createFeedback({
          workdayId,
          firstName,
          lastName,
          middleName,
          suffix,
          email,
          supervisor,
          operationalManager,
          feedback,
          imageFileName,
          imageFile,
        }),
      )
      showToast('success', 'Feedback sent successfully!')
    } catch (err) {
      console.error('Failed to send feedback:', err)
      showToast('error', 'Error sending feedback')
    } finally {
      setLoading(false)
    }
  }

  return { createFeedback: addFeedback }
}

export default useAddFeedback
